import React from "react";
import { Link } from "react-router-dom";
import PageTitle from "../../components/PageTitle";
import { Skeleton } from "../../components/ui/Skeleton";
import { Card } from "../../components/ui/Card";
import { Alert, AlertDescription } from "../../components/ui/Alert";
import EmptyState from "../../components/ui/EmptyState";
import { axiosget } from "../../helpers/httprequest";
import { FiPrinter, FiFileText } from "react-icons/fi";

const MainResult = () => {
  const [loading, setloading] = React.useState(true);
  const [data, setdata] = React.useState(undefined);
  const [regData, setRegData] = React.useState(undefined);

  React.useEffect(() => {
    (async () => {
      try {
        setloading(true);
        const req = await axiosget("ms_course_registration/semesters");
        if (req.data?.type) {
          console.warn(req.data.message);
        } else {
          setdata(req?.data);
        }

        if (!req.data || (Array.isArray(req.data) && req.data.length === 0)) {
          const regReq = await axiosget("ms_course");
          if (!regReq.data?.type) {
            setRegData(regReq.data);
          }
        }
      } catch ({ message }) {
        console.warn(message);
      }
      setloading(false);
    })();
  }, []);

  return (
    <div>
      <PageTitle title="Academic Result" sub="View and print your official semester results" />

      {loading ? (
        <div className="space-y-3 mt-4">
          <Skeleton className="h-12 w-full" />
          {[...Array(4)].map((_, i) => <Skeleton key={i} className="h-16 w-full" />)}
        </div>
      ) : (
        <>
          {data && data.length > 0 ? (
            <div className="space-y-3 mt-4">
              {data.map((v, i) => (
                <Card key={i} padding="none" className="group hover:shadow-md transition-shadow">
                  <div className="flex items-center justify-between px-5 py-4">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center">
                        <FiFileText className="w-5 h-5 text-primary-600" />
                      </div>
                      <div>
                        <h3 className="text-sm font-bold text-neutral-900">{v?.name}</h3>
                        <p className="text-xs text-neutral-500 mt-0.5">{v?.code}</p>
                      </div>
                    </div>
                    <Link
                      to={`/app/print-result/${v._id}`}
                      className="flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold text-primary-600 hover:bg-primary-50 transition-colors no-underline"
                    >
                      <FiPrinter className="w-4 h-4" />
                      Print Result
                    </Link>
                  </div>
                </Card>
              ))}
            </div>
          ) : (
            <div className="mt-4">
              <Alert variant="info">
                <AlertDescription>No published results found. Displaying current semester registration.</AlertDescription>
              </Alert>

              {regData && regData.length > 0 ? (
                <Card padding="none" className="mt-4 overflow-hidden">
                  <div className="overflow-x-auto">
                    <table className="w-full">
                      <thead className="bg-neutral-50 border-b border-neutral-200">
                        <tr>
                          {["#", "Code", "Title", "Unit", "CA", "Exam", "Total", "Grade"].map((h) => (
                            <th key={h} className="px-4 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider">{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-neutral-100">
                        {regData.map((course, index) => (
                          <tr key={course._id} className="hover:bg-neutral-50 transition-colors">
                            <td className="px-4 py-3.5 text-sm font-semibold text-neutral-500">{index + 1}</td>
                            <td className="px-4 py-3.5 text-sm font-bold text-neutral-900">{course.courseinfo?.code || course.code}</td>
                            <td className="px-4 py-3.5 text-sm text-neutral-700">{course.courseinfo?.name || course.name}</td>
                            <td className="px-4 py-3.5 text-sm text-neutral-700">{course.courseinfo?.credit || course.credit}</td>
                            <td className="px-4 py-3.5 text-sm text-neutral-400">-</td>
                            <td className="px-4 py-3.5 text-sm text-neutral-400">-</td>
                            <td className="px-4 py-3.5 text-sm text-neutral-400">-</td>
                            <td className="px-4 py-3.5 text-sm text-neutral-400">-</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </Card>
              ) : (
                <EmptyState variant="no-data" title="No Registrations" description="No course registration found for the current semester." className="mt-4" />
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default MainResult;
